import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { filter, map, take } from 'rxjs';
import { AppInitService } from '../services/app-init.service';

export const authGuard: CanActivateFn = () => {
  const msalService = inject(MsalService);
  const appInitService = inject(AppInitService);
  const router = inject(Router);

  // Wait for app initialization to complete (including silent auth)
  return appInitService.isInitialized().pipe(
    filter((initialized) => initialized === true),
    take(1),
    map(() => {
      // Check if user is authenticated
      const activeAccount = msalService.instance.getActiveAccount();
      if (!activeAccount) {
        const accounts = msalService.instance.getAllAccounts();
        if (accounts.length > 0) {
          msalService.instance.setActiveAccount(accounts[0]);
          return true;
        }
      } else {
        return true;
      }

      // Redirect to login if not authenticated
      router.navigate(['/login']);
      return false;
    }),
  );
};
